import { parseUnits } from "viem/utils";

export const shortHex = (address: string) => {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const bigintMax = (a: bigint, b: bigint) => {
  return a > b ? a : b;
};

export const bigintMin = (a: bigint, b: bigint) => {
  return a < b ? a : b;
};

export function safeParseUnits(value: string, decimals: number) {
  try {
    return parseUnits(value, decimals);
  } catch (error) {
    return null;
  }
}

export function randomToken() {
  const rand = new Uint8Array(4);
  crypto.getRandomValues(rand);
  const suffix = Buffer.from(rand).toString("hex");
  const tokenName = `TestToken${suffix}`;
  const tokenSymbol = `TT${suffix}`;
  const tokenDecimals = 18;

  return {
    tokenName,
    tokenSymbol,
    tokenDecimals,
  };
}

export function l1BlockExplorerUrl(txHash: string) {
  return `https://otterscan-devnet.metacrypt.org/tx/${txHash}`;
}

export function l2BlockExplorerUrl(txHash: string) {
  return `https://aztecscan.xyz/tx/${txHash}`;
}

export function formatTimestamp(timestamp: number) {
  return new Date(timestamp).toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}
